export const storeBySlug = /* GraphQL */ `
  query StoreBySlug($slug: String) {
    storeBySlug(slug: $slug) {
      items {
        id
        createdAt
        status
        code
        slug
        name
        body
        logo {
          type
          key
          bucket
          name
        }
        tags
      }
    }
  }
`;

export const storeByHostname = /* GraphQL */ `
  query StoreByHostname($hostname: String) {
    storeByHostname(hostname: $hostname) {
      items {
        id
        createdAt
        status
        code
        slug
        name
        body
        logo {
          type
          key
          bucket
          name
        }
        tags
      }
    }
  }
`;

export const listProducts = /* GraphQL */ `
  query ListProducts($storeID: ID, $status: ModelIntKeyConditionInput, $nextToken: String) {
    productsByStore(storeID: $storeID, status: $status, nextToken: $nextToken) {
      items {
        id
        storeID
        createdAt
        updatedAt
        status
        name
        price
        body
        tags
        medias {
          type
          key
          bucket
          name
        }
      }
      nextToken
    }
  }
`;

export const listProductsByName = /* GraphQL */ `
  query ListProductsByName(
    $storeID: ID
    $name: ModelStringKeyConditionInput
    $filter: ModelProductFilterInput
  ) {
    productsByName(storeID: $storeID, name: $name, filter: $filter) {
      items {
        id
        storeID
        createdAt
        updatedAt
        status
        name
        price
        body
        tags
        medias {
          type
          key
          bucket
          name
        }
      }
      nextToken
    }
  }
`;

export const getCart = /* GraphQL */ `
  query GetCart($id: ID!) {
    getCart(id: $id) {
      id
      createdAt
      updatedAt
      status
      storeID
      clientID
      orderNumber
      delivery {
        type
        details
      }
      payment {
        type
        details
      }
      ticket
      transactionID
    }
  }
`;

export const getCartFull = /* GraphQL */ `
  query GetCartFull($id: ID!) {
    getCart(id: $id) {
      id
      createdAt
      updatedAt
      status
      storeID
      clientID
      client {
        firstname
        lastname
      }
      orderNumber
      delivery {
        type
        details
      }
      payment {
        type
        details
      }
      ticket
      items
      transactionID
    }
  }
`;

export const getClient = /* GraphQL */ `
  query getClient($email: String!) {
    getClient(email: $email) {
      email
      firstname
      lastname
      phone
      address
      address2
    }
  }
`;
